import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DiagnosticRoutingModule } from './diagnostic-routing.module';
import { AddDiagnosticComponent } from './add-diagnostic/add-diagnostic.component';
import { AssignDiagnosticComponent } from './assign-diagnostic/assign-diagnostic.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiModule } from '../shared/ui/ui.module';
import { NgbDropdownModule, NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { PagesRoutingModule } from '../pages/pages-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [
    AddDiagnosticComponent,
    AssignDiagnosticComponent
  ],
  imports: [
    CommonModule,
    DiagnosticRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    Ng2SearchPipeModule,
    NgbNavModule,
    NgbDropdownModule,
    PagesRoutingModule,
    NgbModule,
    NgSelectModule,
  ]
})
export class DiagnosticModule { }
